import * as $ from 'jquery'
import {Logger} from "../modules/common/log";
import {TumboExtendedReport} from "../modules/extended_report/TumboExtendedReport";
import {initNamespace} from "../modules/common/main/MainTumboApplication";

initNamespace();

/**
 * Inits the extended report, given the localization and configuration objects
 * @param localizationDictionary {object} The localization dictionary
 * @param reportConfiguration {object} The configuration object
 * @param targetElementId {string} The id of the div element where to render the report into
 * @param debug {boolean} if true, the report will log debug messages
 */
function initExtendedReport(localizationDictionary, reportConfiguration, targetElementId, debug) {
    const extendedReport = new TumboExtendedReport(localizationDictionary, reportConfiguration, targetElementId, new Logger(!!debug));
    extendedReport.loadConfig();
    extendedReport.run();
}

/**
 * Inits the extended report, given the localization and configuration services URLs
 * @param localizationDictionaryUrl {string} The localization service URL
 * @param reportConfigurationUrl {string} The configuration service URL
 * @param targetElementId {string} The id of the div element where to render the report into
 * @param debug {boolean} if true, the report will log debug messages
 */
function initExtendedReportFromUrls(localizationDictionaryUrl, reportConfigurationUrl, targetElementId, debug) {
    $.ajax({
        url: reportConfigurationUrl
    }).done(function (extendedReportConfiguration) {
        $.ajax({
            url: localizationDictionaryUrl
        }).done(function (localizationDictionary) {
            if (Object.prototype.toString.call(localizationDictionary) === '[object String]') {
                localizationDictionary = JSON.parse(localizationDictionary);
            }
            initExtendedReport(localizationDictionary, extendedReportConfiguration, targetElementId, debug);
        });
    });
}

window.tumbo.initExtendedReport = initExtendedReport;
window.tumbo.initExtendedReportFromUrls = initExtendedReportFromUrls;
export {initExtendedReport, initExtendedReportFromUrls}